"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_popper_1 = require("react-popper");
var _Core_1 = require("../../_Core");
var Keyboard_1 = require("../../_Core/Keyboard");
var Icon_1 = require("../../Icons/Icon/Icon");
var DropList_1 = require("../../Lists/DropList");
var Modal_1 = require("../../ReactPortalWrapper/Modal");
var Theme_1 = require("../../Theme");
var IconDropdown_styles_1 = require("./IconDropdown.styles");
var defaultProps = {
    AriaLabel: "",
    ButtonSize: "30px",
    DisableAutoFocus: true,
    Icon: _Core_1.Icons.CaretDown,
    IconSize: "24px",
    Placement: "bottom-start",
    Title: "Icon Dropdown",
};
var IconDropdown = function (props) {
    var _a = React.useState(false), showDropDown = _a[0], setShowDropDown = _a[1];
    var _b = React.useState(null), reference = _b[0], setReference = _b[1];
    var _c = React.useState(null), popperElement = _c[0], setPopperElement = _c[1];
    var mergedProps = __assign(__assign({}, defaultProps), props);
    var DropListComponent = Boolean(mergedProps.Skeleton) ? DropList_1.DropListSkeleton : DropList_1.DropList;
    var onBackButtonEvent = function () {
        setShowDropDown(false);
    };
    React.useEffect(function () {
        window.addEventListener("popstate", onBackButtonEvent);
        return function () { return window.removeEventListener("popstate", onBackButtonEvent); };
    }, []);
    var handleButtonOnClick = function (e) {
        e.stopPropagation();
        setShowDropDown(!showDropDown);
    };
    var handleKeyBoardEvents = function (e) {
        e.stopPropagation();
        if (Keyboard_1.IsDownArrow(e)) {
            setShowDropDown(true);
        }
    };
    var getModifiers = function () { return Boolean(mergedProps.Offset)
        ? [
            {
                name: "offset",
                options: {
                    offset: [mergedProps.Offset.Skidding, mergedProps.Offset.Distance],
                },
            },
        ]
        : []; };
    var _d = react_popper_1.usePopper(reference, popperElement, {
        modifiers: getModifiers(),
        placement: mergedProps.Placement,
    }), styles = _d.styles, update = _d.update, attributes = _d.attributes;
    React.useEffect(function () {
        if (update && props.UpdatePopperOnContainerResize && window.ResizeObserver) {
            var observer_1 = new ResizeObserver(function () {
                update();
            });
            observer_1.observe(popperElement);
            return function () { return observer_1.unobserve(popperElement); };
        }
    }, [update]);
    return (React.createElement(React.Fragment, null,
        React.createElement(IconDropdown_styles_1.Button, { "aria-label": mergedProps.AriaLabel, "aria-haspopup": true, "aria-expanded": showDropDown, style: { height: mergedProps.ButtonSize, width: mergedProps.ButtonSize }, ref: setReference, type: "button", disabled: mergedProps.Disabled, title: mergedProps.Title, onClick: handleButtonOnClick, onKeyUp: handleKeyBoardEvents },
            React.createElement(Icon_1.Icon, { Icon: mergedProps.Icon, Width: mergedProps.IconSize, Height: mergedProps.IconSize })),
        showDropDown && (React.createElement(Modal_1.Modal, { DisableAutoFocus: mergedProps.DisableAutoFocus },
            React.createElement(DropListComponent, __assign({ ref: setPopperElement, Style: __assign(__assign({}, styles.popper), { zIndex: Theme_1.portalsZIndex }), OnCloseMenu: function () { return setShowDropDown(false); } }, attributes.popper), mergedProps.children)))));
};
exports.default = IconDropdown;
